module.exports = __webpack_public_path__ + "static/img/nav8.bcdf1774.svg";